import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {VbMenuEntry} from "../../navigation/menu-item.interface";
import {touchStocktakingMenu} from "./touch-stocktaking.menu";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {StocktakingService} from "../../../../store-management/services/stocktaking/stocktaking.service";
import * as _ from "lodash";
import {TouchStocktakingService} from "../touch-stocktaking.service";

@Component({
  selector: 'vb-touch-stocktaking-menu',
  templateUrl: './touch-stocktaking-menu.component.html',
  styleUrls: ['./touch-stocktaking-menu.component.css']
})
export class TouchStocktakingMenuComponent extends AbstractVisbosComponent implements OnInit {

  entries: VbMenuEntry[] = [];

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private stocktakingService: StocktakingService,
              private tsService: TouchStocktakingService) {
    super(sessionActions, cd);
    this.entries = touchStocktakingMenu;
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.setContinueStocktaking(this.tsService.latestStocktaking);

    this.addComponentData(this.tsService.latestStocktaking$);
    this.addSubscription(this.tsService.latestStocktaking$.subscribe(res => {
      this.setContinueStocktaking(res.data.latestStocktaking);
    }));

  }

  private setContinueStocktaking(stocktaking?) {
    let enabled: boolean = stocktaking != null;
    let newMenu = _.cloneDeep(this.entries);
    let b = newMenu.find(i => i.id == 'continueStocktaking');
    b.link = stocktaking ? [stocktaking.cuid] : [''];
    b.visible = enabled;
    this.entries = newMenu;
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-stocktaking/touch-stocktaking-menu/touch-stocktaking-menu.component.ts